// extracted by css-extract-rspack-plugin
export default {"ProjectItemSectionContainer":"ProjectItemSection-module__ProjectItemSectionContainer__t4QfiCA"};